import { Badge, HStack, Icon } from '@chakra-ui/react';
import type { MouseEvent } from 'react';
import { FiInfo } from 'react-icons/fi';
import Tooltip from './Tooltip';

/**
 * La marca de "esto es nuevo y todavía se está puliendo".
 *
 * Vive aparte para que sea idéntica allá donde aparezca: si mañana cambia el
 * texto o el color, cambia en un solo sitio y no se queda una versión vieja
 * suelta por ahí.
 */

export const AVISO =
  'Función nueva, en etapa de evaluación. Si encuentras cualquier problema, repórtalo a Sontickets.';

/**
 * La "i" con su explicación, suelta.
 *
 * Se usa sola donde ya hay una etiqueta que no dice "Beta" —como el "Nuevo"
 * del menú—, para que el icono y el texto sean exactamente los mismos en
 * todas partes.
 */
export const InfoNueva = ({ aviso = AVISO }: { aviso?: string }) => (
  <Tooltip
    hasArrow
    label={aviso}
    placement='bottom'
    openDelay={200}
    fontSize='xs'
    maxW='260px'
    textAlign='center'
    borderRadius='md'
    px={3}
    py={2}
  >
    {/* `tabIndex` para que también se lea con el teclado, no solo con el ratón. */}
    <span
      tabIndex={0}
      style={{ display: 'inline-flex', cursor: 'help', verticalAlign: 'middle' }}
      // En el menú la "i" va dentro del enlace. Sin esto, consultarla llevaría
      // a otra pantalla, que no es lo que espera nadie al pulsar un icono de
      // información.
      onClick={(evento: MouseEvent) => {
        evento.preventDefault();
        evento.stopPropagation();
      }}
    >
      <Icon as={FiInfo} color='gray.400' boxSize={3.5} aria-label={aviso} />
    </span>
  </Tooltip>
);

const MarcaBeta = ({ aviso = AVISO }: { aviso?: string }) => (
  <HStack spacing={1}>
    <Badge colorScheme='purple' fontSize='0.65em' borderRadius='full' px={2}>
      Beta
    </Badge>
    <InfoNueva aviso={aviso} />
  </HStack>
);

export default MarcaBeta;
